import { Card, CardBody, Button, Input, Select, SelectItem, Chip } from "@heroui/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useMemo, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import * as XLSX from 'xlsx';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faList, faSave, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiRoute, ENUM_USER_TYPE, linksUrl, URIEncrypt } from "../../constants/enum";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { connect, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setCompCode } from "../../state/companySlice";
import { Autocomplete, TextField } from "@mui/material";

const UserPartyMapping = () => {
    const { compCode, } = useSelector((state) => state.company)
    const { user } = useSelector((state) => state.auth);
    const [selUserId, setSelUserId] = useState("")
    const [selPartyId, setSelPartyId] = useState([])
    //const [selParty, setSelUser] = useState(new Set([]))
    const navi = useNavigate();


    // const handleChange = (e) => {
    //     const { value, name, } = e.target
    //     setFormData({ ...formData, [name]: value })
    // }
    const handleAutoCompleteChange = (value) => {
        setSelUserId(value)
        filterUserMaping({
            data: {
                userid: value,
                compcode: compCode.join(",")
            }
        })
    }

    const handleSelectionChnage = (keys, name) => {

        setSelPartyId(keys)

    }

    const { data: masterData = [], isLoading } = useFetchWithBody({
        url: apiRoute.userPartyMaping.masterData,
        queryKey: "fungetmasterDatamap",
        inputData: {
            comp_code: compCode.join(","),
            client_code: user.clientCode,
            user_type: ENUM_USER_TYPE.DISTRIBUTOR
        }

    })


    const { data: userMapData = [], mutate: filterUserMaping } = usePost({
        url: apiRoute.userPartyMaping.getPartyMaping,
        queryKey: "getUsermaping",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                const selParty = data.map(ele => String(ele?.PACID ?? ""));
                setSelPartyId(selParty)
                //  setSelUser(new Set(selComp))
            }
            else {
                //setSelUser(new Set([]))
                setSelPartyId([])
            }
        }

    })
    const { data = [], isPending, isError, mutate: funAddUpMaping } = usePost({
        url: apiRoute.userPartyMaping.addUpdate,
        queryKey: "funAddUpdateMap",
        onSuccessTasks: (data) => {
            toast.success("Maping Updated ", {
                position: "top-center"
            })
            //  selU(new Set([]))
            setSelUserId("")
            setSelPartyId([])
        }

    })

    // const handleChange = (e) => {
    //     setSelUser(new Set(e.target.value.split(",")));
    // }
    console.log(selPartyId)
    const handleSubmit = (e) => {
        e.preventDefault();
        funAddUpMaping({
            data: {
                compcode: compCode.join(""),
                partyid: selPartyId,
                userid: selUserId
                // users: [...selUser]
            }
        })
    }

    const handleDelete = (key) => {
        // const newFilter = selCompany
        // newFilter.delete(key)
        // setSelCompany(new Set(newFilter));
    }
    const handleReset = () => {
        // setSelCompany(new Set([]))
        setSelPartyId([])
        setSelUserId("")
    }

    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer pageName={"User Party Mapping"}
            breadcrumbs={["Settings", "User", "Party Mapping"]} >
            <div className="" style={{ textAlign: "right" }}>
            </div>
            <Card>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <CardBody className="h-screen">
                        <div className="flex gap-4 align-top items-baseline mb-2">
                            <div className="flex-row w-full">
                                <label
                                    style={{
                                        display: "block",
                                        fontSize: "12px",
                                        fontWeight: 700,
                                        marginBottom: "4px",
                                    }}
                                >
                                    {"User (Distributor)"}
                                </label>
                                <Autocomplete
                                    size="small"

                                    options={masterData?.userMaster || []} // always fallback to empty array
                                    getOptionLabel={(option) => option["LoginName"] || ""}
                                    placeholder={"User"}
                                    value={
                                        masterData?.userMaster?.find(
                                            (x) => x["LoginName"] === selUserId
                                        ) || null
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option["LoginName"] === value["LoginName"]
                                    }
                                    onChange={(event, newValue) => {
                                        handleAutoCompleteChange(
                                            newValue ? newValue["LoginName"] : "",
                                            "user"
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) =>
                                        option["LoginName"] === value["LoginName"]
                                    }
                                    noOptionsText="No options available"

                                    sx={{
                                        width: "100%",
                                        // "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important",  background: "#FFFFFF" },
                                        // "& .MuiOutlinedInput-root": { padding: "0px !important",  },

                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={""}
                                            variant="outlined"
                                            required
                                            placeholder="--Select--"
                                            // error={!!errors[item.name]}
                                            // helperText={errors[item.name] || ""}
                                            size="small"
                                            inputProps={{
                                                ...params.inputProps, // ⚡ make sure inputProps exist
                                                autoComplete: "off"
                                            }}
                                            sx={{
                                                //width: "150px",

                                                "& .MuiInputLabel-root": { fontSize: "11px" }
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            {/* <Autocomplete
                                size="md"
                                name={"user"}
                                label={"User (Distributor)"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={""}
                                isRequired
                                variant="bordered"
                                isLoading={isLoading}
                               // color="warning"
                                className="max-w-23 font-semibold text-xs"
                                classNames={{
                                    "label": "font-semibold text-xs",
                                }}
                                isClearable={true}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    masterData && masterData.userMaster ? masterData.userMaster : []
                                }
                                onSelectionChange={handleAutoCompleteChange}
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={selUserId}
                            >
                                {(list) => (
                                    <AutocompleteItem
                                        key={list.LoginName}
                                    >
                                        {`${list.LoginName} - ${list.FirstName} ${list.LastName}`}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete> */}


                        </div>
                        <div className="flex gap-4 align-top items-center mb-2">

                            <div className="flex-row w-full">
                                <label
                                    style={{
                                        display: "block",
                                        fontSize: "12px",
                                        fontWeight: 700,
                                        marginBottom: "4px",
                                    }}
                                >
                                    {"Party"}
                                </label>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    options={masterData?.partyMaster || []}
                                    getOptionLabel={(option) => option["Party_Name"] || ""}
                                    placeholder={"Party"}
                                    value={
                                        masterData?.partyMaster?.filter((x) =>
                                            (selPartyId || []).includes(x["Party_Id"])
                                        ) || []
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option["Party_Id"] === value["Party_Id"]
                                    }
                                    onChange={(event, newValue) => {
                                        handleSelectionChnage(
                                            newValue.map((x) => x["Party_Id"]), // array of ids
                                            "party"
                                        );
                                    }}
                                    sx={{
                                        width: "100%"
                                    }}
                                    noOptionsText="No options available"
                                    slotProps={{
                                        chip: {
                                            size: "small",
                                            color: "secondary",
                                            variant: "outlined",
                                            sx: {
                                                height: 20,
                                                fontSize: "10px",
                                                "& .MuiChip-label": {
                                                    padding: "0 4px",
                                                },
                                            },
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                           // required
                                            // error={!!errors["p"]}
                                            // helperText={errors[item.name] || ""}
                                            placeholder={
                                                (selPartyId || []).length === 0
                                                    ? "--Select--"
                                                    : ""
                                            }
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: "off",
                                            }}

                                        />
                                    )}
                                /></div>
                            {/* <Autocomplete
                                size="md"
                                name={"party"}
                                label={"Party"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={""}
                                isRequired
                                 variant="bordered"
                                isLoading={isLoading}
                               // color="warning"
                                className="max-w-23 font-semibold"
                                classNames={{
                                    label: "font-semibold",
                                }}
                                isClearable={true}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    masterData && masterData.partyMaster ? masterData.partyMaster : []
                                }
                                onSelectionChange={setSelPartyId}
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={selPartyId}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.Party_Id}
                                    >
                                        {`${list.Party_Name}`}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete> */}




                        </div>

                        <div className="flex  justify-center gap-4 align-top items-center mb-2">
                            <Button
                                color="primary"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Save
                            </Button>
                            <Button
                                color="default"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                onPress={handleReset}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancle
                            </Button>
                        </div>
                    </CardBody>
                </form>
            </Card>
        </MainContainer>
    )
}
export default UserPartyMapping